<template>
  <div>
    <ChapterHead>
      <span>协议编号：{{formData.protocolId}}</span>
      <span slot="extra">
        <el-button v-if="!protocolId" type="primary" size="small" icon="el-icon-back" @click="back">返回</el-button>
      </span>
    </ChapterHead>
    <el-form ref="formData" :loading="loading" :model="formData" :rules="formRules" :inline="true" label-width="180">
      <el-row>
        <el-col :span="6">
          <el-form-item label="协议标题" prop="protocolTitle">
            <el-input type="text" disabled v-model="formData.protocolTitle" size="small" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="救助医院" prop="hospitalName">
            <el-input type="text" disabled v-model="formData.hospitalName" size="small" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="批次" prop="batchNo">
            <el-input type="text" disabled v-model="formData.batchNo" size="small" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="协议类型" prop="protocolTypeName">
            <el-input type="text" disabled v-model="formData.protocolTypeName" size="small" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="患儿人次" prop="childCount">
            <el-input type="text" disabled v-model="formData.childCount" size="small" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="患儿人数" prop="childSum">
            <el-input type="text" disabled v-model="formData.childSum" size="small" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="总救助费用" prop="totalHelpAmount">
            <el-input type="text" disabled :value="parseFloat(formData.totalHelpAmount || 0).toFixed(2)" size="small" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="费用大写" prop="totalHelpAmountCn">
            <el-input type="text" disabled v-model="formData.totalHelpAmountCn" size="small" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <el-form-item label="协议扫描件" prop="attachList">
            <FileUpload v-model="formData.attachList" :disabled="true"></FileUpload>
          </el-form-item>
        </el-col>
      </el-row>
      <ChapterHead>辅助信息</ChapterHead>
      <el-row>
        <el-col :span="6">
          <el-form-item label="生成时间" prop="createTime">
            <el-date-picker
              v-model="formData.createTime"
              align="right"
              size="small"
              type="date"
              placeholder="选择时间"
              :disabled="true"></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="收款账号" prop="accountBankNo">
            <el-input v-if="formData.accountBankNo" type="text" disabled v-model="formData.accountBankNo" size="small" />
            <el-input v-else type="text" disabled value="-" size="small" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="收款账户" prop="accountName">
            <el-input v-if="formData.accountName" type="text" disabled v-model="formData.accountName" size="small" />
            <el-input v-else type="text" disabled value="-" size="small" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="开户网点" prop="accountBranch">
            <el-input v-if="formData.accountBranch" type="text" disabled v-model="formData.accountBranch" size="small" />
            <el-input v-else type="text" disabled value="-" size="small" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <el-form-item label="收到发票" prop="isReceivedBill">
            <el-radio-group v-model="formData.isReceivedBill" :disabled="true">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="发票时间" prop="receivedBillTime">
            <el-date-picker
              v-if="formData.receivedBillTime"
              v-model="formData.receivedBillTime"
              size="small"
              type="date"
              :disabled="true"></el-date-picker>
            <el-input v-else type="text" disabled value="-" size="small" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="是否汇款" prop="isRemit">
            <el-radio-group v-model="formData.isRemit" :disabled="true">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="汇款时间" prop="remitTime">
            <el-date-picker
              v-if="formData.remitTime"
              v-model="formData.remitTime"
              size="small"
              type="date"
              :disabled="true"></el-date-picker>
            <el-input v-else type="text" disabled value="-" size="small" />
          </el-form-item>
        </el-col>
      </el-row>
      <!-- <el-row>
        <el-col :span="6">
          <el-form-item label="有无回单" prop="isBankReceipt">
            <el-radio-group v-model="formData.isBankReceipt" :disabled="true">
              <el-radio :label="1">有</el-radio>
              <el-radio :label="0">无</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row> -->
      <div v-if="relationList && relationList.length > 0">
        <el-row v-for="item in relationList" :key="item.applyId">
          <el-col :span="6">
            <el-form-item label="退补款编号">
              <TableCellWordBreak :content="item.applyId">
                <span style="color: #E8556F; text-decoration: none; cursor: pointer;" @click="toRsDetail(item, item.applyType)">{{item.applyId}}</span>
              </TableCellWordBreak>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="类型">
              <el-radio-group v-model="item.applyType" :disabled="true">
                <el-radio :label="2">补款</el-radio>
                <el-radio :label="3">退款</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="金额">
              <el-input type="text" disabled :value="parseFloat(item.totalHelpAmount).toFixed(2)" size="small">
                <span slot="suffix">元</span>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>
    <ChapterHead>患儿信息</ChapterHead>
    <el-table :data="tableData" v-loading="tableLoading" style="width: 100%" max-height="480px">
      <el-table-column key="index" type="index" width="50" label="序号" fixed="left" align="center"></el-table-column>
      <el-table-column prop="outlayId" width="150" label="费用编号">
        <template slot-scope="scope">
          <span class="link" @click="outlayFillIn(scope.row)">{{
            scope.row.outlayId
          }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="outlayTime" width="100" label="申请时间">
        <template slot-scope="scope">
          <span>{{ parseTime(scope.row.outlayTime, '{y}-{m}-{d}') }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="childName" label="患儿姓名" width="110">
        <template slot-scope="scope">
          <TableCellWordBreak :content="scope.row.childName"></TableCellWordBreak>
        </template>
      </el-table-column>
      <el-table-column prop="birthday" width="100" label="出生日期"></el-table-column>
      <el-table-column prop="diseasesName" width="200" label="病种">
        <template slot-scope="scope">
          <TableCellWordBreak :content="scope.row.afterDiseasesName || scope.row.beforeDiseasesName"></TableCellWordBreak>
        </template>
      </el-table-column>
      <el-table-column prop="curStages" label="期次" width="50">
        <template slot-scope="scope">
          {{scope.row.curStages + '/' + (scope.row.initialProject == 'AY1002' ? '-' : (scope.row.totalStages || '-'))}}
        </template>
      </el-table-column>
      <el-table-column prop="outlayTypeName"  label="费用类型">
      </el-table-column>
      <el-table-column v-if="formData.outlayType == 1" prop="operationAmount" label="治疗总费用" width="90" align="right">
        <template slot-scope="scope">
           <span v-if="scope.row.initialProject == 'AY1002'">
<!--            <span class="link" @click="outlayFillIn(scope.row)">{{ parseFloat(scope.row.selfPayAmount || '0').toFixed(2) }}</span>-->
             <span>-</span>
          </span>
          <span v-else>{{parseFloat(scope.row.operationAmount || '0').toFixed(2)}}</span>
        </template>
      </el-table-column>
      <el-table-column v-if="formData.outlayType == 1" prop="reimburAmount" label="医保报销" width="90" align="right">
        <template slot-scope="scope">
          <span v-if="scope.row.initialProject == 'AY1002'">-</span>
          <span v-else>{{parseFloat(scope.row.reimburAmount || '0').toFixed(2)}}</span>
        </template>
      </el-table-column>
      <el-table-column v-if="formData.outlayType == 1" prop="otherHelp" label="其他资助" width="90" align="right">
        <template slot-scope="scope">
          <span v-if="scope.row.initialProject == 'AY1002'">-</span>
          <span v-else>{{parseFloat(scope.row.otherHelp || '0').toFixed(2)}}</span>
        </template>
      </el-table-column>
      <el-table-column v-if="formData.outlayType == 1" prop="hospitalReduction" label="医院减免" width="90" align="right">
        <template slot-scope="scope">
          <span v-if="scope.row.initialProject == 'AY1002'">-</span>
          <span v-else>{{parseFloat(scope.row.hospitalReduction || '0').toFixed(2)}}</span>
        </template>
      </el-table-column>
      <el-table-column v-if="formData.outlayType == 2" prop="checkTime" width="100" label="检查时间">
        <template slot-scope="scope">
          {{parseTime(scope.row.checkTime, '{y}-{m}-{d}')}}
        </template>
      </el-table-column>
      <el-table-column v-if="formData.outlayType == 2" prop="billCount" width="80" label="发票张数"></el-table-column>
      <el-table-column v-if="formData.outlayType == 2" prop="checkOutlay" width="90" label="检查费用" align="right">
        <template slot-scope="scope">
          <span>{{parseFloat(scope.row.checkOutlay || '0').toFixed(2)}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="helpAmount" label="救助费用" width="120" align="right">
        <template slot-scope="scope">
          <span class="link" @click="outlayFillIn(scope.row)">{{parseFloat(scope.row.helpAmount || '0').toFixed(2)}}</span>
        </template>
      </el-table-column>
      <el-table-column v-if="formData.outlayType == 1" prop="selfPayAmount" label="自付费用" width="90" align="right">
        <template slot-scope="scope">
            <span v-if="scope.row.initialProject == 'AY1002'">
            {{ parseFloat((scope.row.selfPayAmount || 0) - (scope.row.helpAmount || 0)).toFixed(2) }}
          </span>
          <span v-else>{{parseFloat(scope.row.selfPayAmount || '0').toFixed(2)}}</span>
        </template>
      </el-table-column>
      <el-table-column v-if="formData.outlayType == 2" prop="specialQuota" width="90" label="救助限额" align="right">
        <template slot-scope="scope">
          <span>{{parseFloat(scope.row.specialQuota || '0').toFixed(2)}}</span>
        </template>
      </el-table-column>
    </el-table>
    <div style="height: 16px;"></div>
    <!-- <ChapterHead>备注信息</ChapterHead>
    <el-form :inline="true">
      <el-row>
        <el-col :span="12">
          <el-form-item label="备注" prop="remark">
            <el-input type="textarea" disabled :rows="3" v-model="formData.remark" size="small" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form> -->

    <el-dialog
      title="治疗费用"
      :loading="dialogLoading"
      :visible.sync="cureVisible"
      v-if="cureVisible"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      @close="closeDialog"
      width="1200px">
        <el-tabs v-model="dialogActiveName">
          <el-tab-pane label="费用信息" name="outlayInfo">
            <CureOutlayDetail
              v-if="dialogActiveName == 'outlayInfo'"
              ref="cureOutlay"
              :outlayId="rowData.outlayId"
              :belongProject="rowData.initialProject"
              @close="closeDialog"
              @success="formSaveSuccess">
            </CureOutlayDetail>
          </el-tab-pane>
          <el-tab-pane label="审核记录" name="outlayHistory">
            <OutlayHistory v-if="dialogActiveName == 'outlayHistory'" :outlayId="rowData.outlayId"></OutlayHistory>
          </el-tab-pane>
        </el-tabs>
    </el-dialog>
    <CheckOutlayDialog v-if="checkVisible" :dialogVisible.sync="checkVisible" :rowData="rowData" :recordId="rowData.outlayId" @success="formSaveSuccess"></CheckOutlayDialog>
    <ProtocolInfoDialog
      :visible="relationVisible"
      v-if="relationVisible"
      :protocolId="relationRow.protocolId" 
      :applyType="relationRow.applyType" 
      :applyId="relationRow.applyId" 
      @close="relationVisible = false">
    </ProtocolInfoDialog>
  </div>
</template>

<script>
import { getProtocolDataById, getHospitalBankAccountList, protocolAudit, getProtocolListByRelationId } from "@/util/api.js";
import ChapterHead from "@/components/business/ChapterHead";
import FileUpload from "@/components/business/FileUpload";
import DictionarySelect from "@/components/business/DictionarySelect";
import CureOutlayDetail from "@/pages/outlay/cure/CureOutlayDetail";
import CheckOutlayDialog from "@/pages/outlay/check/CheckOutlayDialog";
import OutlayHistory from "@/pages/outlay/view/OutlayHistory";
import TableCellWordBreak from "@/components/business/TableCellWordBreak"

export default {
  components: {
    ChapterHead,
    TableCellWordBreak,
    DictionarySelect,
    FileUpload,
    CureOutlayDetail,
    CheckOutlayDialog,
    ProtocolInfoDialog: () => import('@/pages/protocol/view/ProtocolInfoDialog'),
    OutlayHistory
  },
  props: {
    protocolId: {
      type: String
    },
    readOnly: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      loading: false,
      dialogLoading: false,
      tableLoading: false,
      cureVisible: false,
      checkVisible: false,
      dialogActiveName: 'outlayInfo',
      formData: {},
      formRules: {},
      tableData: [],
      rowData: {},
      relationList: [],
      relationVisible: false,
      relationRow: {},
      bankAccountOptions: []
    };
  },
  mounted () {
    this.loadData();
  },
  watch: {
    protocolId () {
      this.loadData()
    }
  },
  methods: {
    loadData () {
      let id = this.protocolId || this.$route.params.id;
      if (id) {
        this.tableLoading = true;
        getProtocolDataById(id).then(res => {
          this.tableLoading = false;
          if (res.msgCode == 200) {
            this.formData = res.responseData;
            this.tableData = this.formData.helpList;
            if (this.formData.scanCopy) {
              this.formData.attachList = this.formData.scanCopy.indexOf(',') < 0 ? [this.formData.scanCopy] : this.formData.scanCopy.split(',');
            }
            if (this.formData.totalHelpAmountCn && this.formData.totalHelpAmountCn.substring(this.formData.totalHelpAmountCn.length - 1) == '元') {
              this.formData.totalHelpAmountCn += '整';
            }
            // 当为个案协议时，将银行账号信息设置到协议中
            if (this.formData.protocolType == 2 && this.tableData.length > 0) {
              this.formData.accountName = this.formData.accountName || this.tableData[0].accountName;
              this.formData.accountBank = this.formData.accountBank || this.tableData[0].accountBank;
              this.formData.accountBankNo = this.formData.accountBankNo || this.tableData[0].accountBankNo;
              this.formData.accountBranch = this.formData.accountBranch || this.tableData[0].accountBranch;
            }

            getHospitalBankAccountList({
              hospitalId: this.formData.hospitalId,
              accountStatus: 1
            }).then(bank => {
              if (bank.msgCode == 200 && bank.responseData.modelData && bank.responseData.modelData.length > 0) {
                this.bankAccountOptions = bank.responseData.modelData.map(b => {
                  return Object.assign({
                    valueCode: b.account,
                    valueName: b.accountName
                  }, b);
                });
                if (this.bankAccountOptions.length == 1) {
                  this.formData.account = this.formData.account || this.bankAccountOptions[0].account;
                  this.accountChange(this.formData.account);
                }
              }
            });
            this.$emit('load', this.formData);
            // 关联协议信息加载
            getProtocolListByRelationId(id, 2).then(res => {
              if (res.msgCode == 200) {
                this.relationList = res.responseData.modelData;
              }
            });
          }
        })
      }
    },
    accountChange (val) {
      let current = this.bankAccountOptions.filter(b => {
        return b.valueCode == val;
      });
      if (current && current.length > 0) {
        this.formData.account = current[0].account;
        this.formData.accountName = current[0].accountName;
        this.formData.accountBank = current[0].accountBank;
        this.formData.accountBranch = current[0].accountBranch;
      } else {
        this.formData.account = null;
        this.formData.accountName = null;
        this.formData.accountBank = null;
        this.formData.accountBranch = null;
      }
    },
    completeProtocol () {
      this.$confirm('是否确认审批通过该协议？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        return protocolAudit(Object.assign({
          operation: 'complete'
        }, this.formData));
      }).then(res => {
        if (res.msgCode == '200') {
          this.$message.success('审批成功');
          this.back();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    outlayFillIn(row) {
      this.rowData = row;
      if (this.rowData.outlayType == 1) {
        this.cureVisible = true;
        this.checkVisible = false;
      } else {
        this.cureVisible = false;
        this.checkVisible = true;
      }
      this.dialogLoading = true;
    },
    closeDialog () {
      this.cureVisible = false;
      this.checkVisible = false;
      this.rowData = {}
    },
    formSaveSuccess () {
      this.dialogLoading = false;
      this.closeDialog();
    },
    rollbackProtocol () {

    },
    toRsDetail (row, applyType) {
      this.relationRow = row;
      this.relationVisible = true;
    },
    back () {
      this.$router.go(-1)
    }
  }
};
</script>

<style lang="scss" scoped>
@import 'src/common/common.scss';
@import 'src/common/form.scss';
@import 'src/common/dialog.scss';

/deep/ .applyTable .el-table__body .el-table__row {
  height: 70px;
}
/deep/ .applyTableOverFlow .el-table__body-wrapper {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/protocol/view/ProtocolInfo.vue